// extracted by mini-css-extract-plugin
export default {"title":"style_title__XROgR","buttonWrapper":"style_buttonWrapper__8sX28","modalActionsWrapper":"style_modalActionsWrapper__bUarG","caption":"style_caption__pxzCi"};